import { Product, ProductItem, ProductItemFormData } from "../types/products";

const optionalString = (
  value: string | null | undefined
): string | undefined => {
  if (value == null) return undefined;
  const trimmed = value.trim();
  return trimmed === "" ? undefined : trimmed;
};

const optionalNumber = (
  value: number | null | undefined
): number | undefined => {
  if (value == null || Number.isNaN(value)) return undefined;
  return value;
};

/**
 * Builds create payload by cloning an existing product item row.
 * Optional fields use `undefined` (never `null`) so Yup optional rules pass.
 */
export const productItemFormDataFromBaseItem = (
  baseItem: ProductItem,
  product: Product
): ProductItemFormData => {
  return {
    productId: baseItem.productId,
    storeId: baseItem.storeId?.trim() || product.storeId?.trim() || "",
    totalQuantity: baseItem.totalQuantity,
    unit: (product.unit ?? product.baseUnit) as ProductItemFormData["unit"],
    purchasePrice: baseItem.purchasePrice ?? 0,
    salesPrice: baseItem.salesPrice ?? baseItem.price ?? 0,
    minSalesPrice: baseItem.minSalesPrice ?? 0,
    variationName:
      (baseItem.variationName && baseItem.variationName.trim()) ||
      product.name ||
      "Item",
    weight: optionalNumber(baseItem.weight),
    height: optionalNumber(baseItem.height),
    width: optionalNumber(baseItem.width),
    color: optionalString(baseItem.color),
    thickness: optionalNumber(baseItem.thickness),
    packSize: optionalString(baseItem.packSize),
    material: optionalString(baseItem.material),
    packagingType: optionalString(baseItem.packagingType),
    expirationDate: optionalString(baseItem.expirationDate),
    productionDate: optionalString(baseItem.productionDate),
    lotNumber: optionalString(baseItem.lotNumber)
  };
};
